import { Purchases, LogLevel } from '@revenuecat/purchases-js';

// Must match the entitlement identifier configured in the RevenueCat dashboard.
export const REVENUECAT_PRO_ENTITLEMENT = 'BLACKDEFYNITION Pro';

const REVENUECAT_API_KEY = process.env.REACT_APP_REVENUECAT_PUBLIC_API_KEY;

if (process.env.NODE_ENV !== 'production') {
    Purchases.setLogLevel(LogLevel.Debug);
}

// The SDK only allows a single configured instance, so switching between
// logged-in users re-identifies the existing instance instead of reconfiguring.
export const configureRevenueCat = async (appUserId) => {
    if (!appUserId) return null;

    if (Purchases.isConfigured()) {
        const existing = Purchases.getSharedInstance();
        if (existing.getAppUserId() !== appUserId) {
            await existing.changeUser(appUserId);
        }
        return existing;
    }

    return Purchases.configure({
        apiKey: REVENUECAT_API_KEY || "strp_sb_mHDkVbwMgeSKEVmctVNAbNxn",
        appUserId,
    });
};

export const getRevenueCatInstance = () => {
    return Purchases.isConfigured() ? Purchases.getSharedInstance() : null;
};
